export default [
  {
    path: '/jornalistas',
    name: 'jornalistas',
    component: () => import('@/views/area-mention/jornalistas/index.vue'),
    meta: {
      title: 'Jornalistas',
      authRequired: true,
      roles: [],
    },
  },
]
